import {Directive, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortalDirective} from "@angular/cdk/portal";

@Directive({
  selector: '[table-column-content]',
  exportAs: 'content'
})
export class TableColumnContentDirective extends TemplatePortalDirective {

  constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }

  toString(): string {
    return "TableColumnContent";
  }

  public record: any;

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/components/data-table/table-column-content.directive.ts